export const zobjectUpdated = (subpatch, {zobject, text}) => {
    subpatch.instances.forEach(
        instance => {
            let _zobject = instance.lookupObject(zobject);
            if (_zobject) {
                _zobject.text = text;
            }
        });
};

export const zmessageUpdated = (subpatch, {zmessage, text}) => {
    subpatch.instances.forEach(
        instance => {
            let _zmessage = instance.lookupObject(zmessage);
            if (_zmessage) {
                _zmessage.text = text;
            }
        });
};

export const inletToggled = (subpatch, {inletNumber}) => {
    subpatch.instances.forEach(
        instance => {
            let inlet = instance.inletObjects.find(x => x.inletNumber === inletNumber);
            instance.toggleInlet(inlet);
        });
};

